export default __webpack_public_path__ + "static/media/Byby_Font.3a1c36fd.otf";